import { SET_USER_STATE } from '../constants/redux_types'

export const setUserState = payload => {
  return {
    type: SET_USER_STATE,
    payload: payload
  }
}
